import request from '@/utils/request'

/** 社区列表 */
export function getCommunityList(keyword, page = 1, size = 10) {
  return request({
    url: '/manage/community/list',
    method: 'post',
    params: { keyword, page, size }
  })
}

/** 社区全部列表 */
export function getCommunityNameList() {
  return request({
    url: '/manage/community/communityNameList',
    method: 'post'
  })
}

/** 新增/编辑社区 */
export function saveCommunity(data) {
  return request({
    url: '/manage/community/save',
    method: 'post',
    data
  })
}

/** 删除社区 */
export function deleteCommunity(id) {
  return request({
    url: `/manage/community/del/${id}`,
    method: 'post'
  })
}

/** 工作人员列表 */
export function getStaffList(communityId, page = 1, size = 10) {
  return request({
    url: '/manage/community/staff/list',
    method: 'post',
    params: { communityId, page, size }
  })
}

/** 新增工作人员 */
export function addStaff(data) {
  return request({
    url: '/manage/community/staff/add',
    method: 'post',
    data
  })
}

/** 修改工作人员 */
export function updateStaff(data) {
  return request({
    url: '/manage/community/staff/update',
    method: 'post',
    data
  })
}

/** 启用/禁用工作人员 */
export function toggleStaff(id) {
  return request({
    url: `/manage/community/staff/toggle/${id}`,
    method: 'post'
  })
}

/** 重置密码 */
export function resetStaffPwd(id, newPwd) {
  return request({
    url: `/manage/community/staff/reset-pwd/${id}`,
    method: 'post',
    data: { newPwd }
  })
}
